
import Photo from "../styles/img/CodePicture.jpg"

const TempPage = () => {

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", minHeight: "100vh", backgroundColor: "rgb(19, 30, 37)", textAlign: "center" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "50vh", width: "100%" }}>
            <div style={{ margin: "0 auto", maxWidth: "200px", padding: "0px" }}>
                <img src={Photo} alt="Under maintenance" style={{ maxWidth: "100%", height: "auto", borderRadius: "50%",  borderColor: "rgb(255, 255, 255)", borderStyle: "solid"}} />
            </div>
            <div style={{ margin: "0 auto", maxWidth: "80%" }}>
                <p style={{ color: "#ffffff", fontSize: "2em", fontFamily: "'Permanent Marker', cursive", margin: "0" }}>Under Maintenance</p>
            </div>
            </div>
        </div>
    );
};

export default TempPage;